import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Box, InputBase } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { AppDrawer } from "components";
import { makeStyles } from "@mui/styles";
import SelectingListContact from "../SelectingListContact";
import { useCreateConversation } from "hooks";
import { useSelector } from "react-redux";

const AddingGroupDrawer = ({ onComplete, ...otherProps }) => {
  const classes = useStyles();
  const groupNameRef = useRef("");
  const { createGroup } = useCreateConversation();

  const { t: getLabel } = useTranslation(LangConstant.NS_HOME);
  const chatObjContent = getLabel(LangConstant.OBJ_ADDING_CHAT, { returnObjects: true });

  const newGroupId = useSelector(state => state.groupInfoRedux.newGroupId);

  const [isFetching, setIsFetching] = useState(false);

  const onChangeGroupName = event => {
    groupNameRef.current = event.target.value;
  };

  const onCreateGroup = memberList => {
    setIsFetching(true); // Start adding group
    createGroup(memberList, (groupNameRef.current || "").trim());
  };

  useEffect(() => {
    // callback when complete adding group
    if (isFetching && newGroupId) {
      if (onComplete) onComplete();
    }
  }, [isFetching, newGroupId]);

  return (
    <AppDrawer title={chatObjContent.createGroup} {...otherProps}>
      <InputBase
        fullWidth
        className={classes.inputGroupName}
        placeholder={chatObjContent.groupPlaceHolder}
        onChange={onChangeGroupName}
        inputProps={{ maxLength: SystemConstant.MAX_NAME_LENGTH }}
      />
      <Box className={classes.memberContainer}>
        <SelectingListContact onComplete={onCreateGroup} minimumLimit={SystemConstant.MINIMUM_SELECT_CONTACT} />
      </Box>
    </AppDrawer>
  );
};

AddingGroupDrawer.propTypes = {
  isConferenceFlow: PropTypes.bool,
  onComplete: PropTypes.func,

  ...AppDrawer.propTypes,
};

AddingGroupDrawer.defaultProps = {};

export default AddingGroupDrawer;

const useStyles = makeStyles({
  inputGroupName: {
    padding: 16,
    height: 62,
    "&, & input": { fontWeight: 700, fontSize: "0.875rem", color: "#1E272E", textAlign: "center" },
  },

  memberContainer: {
    height: "calc(100% - 62px)",
  },
});
